exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".UserOrganisation{width:100%;padding-bottom:20px;padding-top:20px;display:flex;justify-content:center;height:100%}.UserOrganisation .row{max-width:1240px;width:100%}.UserOrganisation .row .btn-create{height:32px;min-width:165px;background-color:#fff;border:1px solid #00adff;color:#00adff;padding:0 10px;border-radius:25px;text-transform:uppercase;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;cursor:pointer}.UserOrganisation .row .btn-create:hover{color:#fff;background-color:#00adff}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/UserOrganisation/style.scss
// module id = 5103
// module chunks = 0